import { Stack } from '@chakra-ui/react';
import { parseAsString, useQueryState } from 'nuqs';
import React, { useEffect } from 'react';
import { AffiliateFilter } from '@/components/filters/AffiliateFilter';
import { usePendingPayoutStore } from '@/stores/pending-payout-store';

export const PendingCommissionsFilters: React.FC = () => {
  // URL state management with nuqs
  const [urlAffiliateIds] = useQueryState('pendingAffiliateIds', parseAsString);

  // Zustand store actions
  const setFilters = usePendingPayoutStore((state) => state.setFilters);
  const clearSelection = usePendingPayoutStore((state) => state.clearSelection);

  // Sync Zustand store with URL state
  useEffect(() => {
    const affiliateIds = urlAffiliateIds ? urlAffiliateIds.split(',').filter(Boolean) : [];
    clearSelection(); // Clear pending selections when filters change
    setFilters({
      affiliateIds: affiliateIds.length > 0 ? affiliateIds : undefined,
    });
  }, [urlAffiliateIds, setFilters, clearSelection]);

  // Render filters - AffiliateFilter will manage its own URL state
  return (
    <Stack direction={{ base: 'column', md: 'row' }} gap={2}>
      <AffiliateFilter paramPrefix="pending" />
    </Stack>
  );
};
